import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { mcpOrgContextQueryKey } from "./useMcpOrgContext";

interface SetOrgContextParams {
  serverId: string;
  context: string;
}

export function useSetMcpOrgContext(orgId: string | undefined) {
  const { mcpRegistryService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ serverId, context }: SetOrgContextParams) =>
      mcpRegistryService.setOrgContext(serverId, orgId!, context),
    onSuccess: (_data, { serverId }) => {
      void queryClient.invalidateQueries({
        queryKey: mcpOrgContextQueryKey(serverId, orgId),
      });
    },
  });
}
